import * as React from 'react';

import { Checkbox, Grid, Link, Typography } from '@emburse/ui-core';

interface ILink {
  href: string;
  text: string;
}

export const SignUpTerms: React.FC<{
  checked: boolean;
  error: boolean;
  onChange: (newCheckedState: boolean) => void;
  whitelabelName: string;
  partner_id?: string;
}> = ({ checked, error, onChange, whitelabelName, partner_id }) => {
  const getLinks = () => {
    const links: ILink[] = [
      {
        href: window.whitelabelConfiguration?.tags?.termsOfService,
        text: (whitelabelName === 'Emburse Spend' ? 'Emburse' : whitelabelName) + ' Terms'
      }
    ];

    if (partner_id === 'amex') {
      links.push({
        href: window.whitelabelConfiguration.tags.termsOfServiceAmex,
        text: 'American Express Terms'
      });
    }
    links.push({
      href: window.whitelabelConfiguration?.tags?.privacyPolicy,
      text: 'Privacy Policy'
    });
    return links;
  };

  return (
    <>
      <Grid container alignItems={'center'}>
        <Grid>
          <Checkbox
            className={error ? 'errorRed' : ''}
            color="primary"
            checked={checked}
            name="tos_accepted"
            required
            onChange={() => onChange(!checked)}
            style={{ marginRight: 5 }}
          />
        </Grid>
        <Grid item sm>
          <Typography variant="body2">
            By activating your account, you agree to the{' '}
            {getLinks().map((link, index, array) => {
              return (
                <>
                  <Link href={link.href} target="_blank" underline="none">
                    {link.text}
                  </Link>
                  {index < array.length - 2 && ', '}
                  {index === array.length - 2 && ', and '}
                </>
              );
            })}
          </Typography>
        </Grid>
      </Grid>
      {error && (
        <Typography variant="caption" className="errorRed" sx={{ paddingLeft: '50px' }}>
          * Please accept the terms and conditions
        </Typography>
      )}
    </>
  );
};
